var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive cont-table"},[_c('b-table',{staticClass:"table",attrs:{"items":_vm.data,"fields":_vm.setFields(),"tbody-tr-class":_vm.rowClass}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }